import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseComponent } from "./modules/layout/base/base.component";
import { AuthGuard } from "./core-features/auth-guard/auth.guard";
import { ErrorPageComponent } from "./shared/error-page/error-page.component";

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./modules/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        // redirectTo: 'dashboard',
        // pathMatch: 'full'
      },
      {
        path: "application-token",
        loadChildren: () =>
          import("./modules/application-token/application-token.module").then(
            (m) => m.ApplicationTokenModule
          ),
      },
      {
        path: "home",
        loadChildren: () =>
          import("./modules/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      // {
      //   path: 'things-manager',
      //   loadChildren: () => import('./modules/thing-manager/thing-manager.module').then(m => m.ThingManagerModule)
      // },
      // {
      //   path: 'things-manager',
      //   loadChildren: () => import('./modules/thing-manager/thing-manager.module').then(m => m.ThingManagerModule)
      // },
      {
        path: "projects",
        loadChildren: () =>
          import("./modules/project/project.module").then(
            (m) => m.ProjectModule
          ),
      },
      {
        path: "templates",
        loadChildren: () =>
          import("./modules/templates/template.module").then(
            (m) => m.TemplateModule
          ),
      },
      {
        path: "rules-engine",
        loadChildren: () =>
          import("./modules/rules-engine/rules-engine.module").then(
            (m) => m.RulesEngineModule
          ),
      },
      {
        path: "reciepint",
        loadChildren: () =>
          import("./modules/reciepint/reciepint.module").then(
            (m) => m.ReciepintModule
          ),
      },
      {
        path: "dashboard/dashboard-builder/:Id",
        loadChildren: () =>
          import("./modules/dashboard-builder/dashboard-builder.module").then(
            (m) => m.DashboardBuilderModule
          ),
      },
      {
        path: "users",
        loadChildren: () =>
          import("./modules/users/user.module").then((m) => m.UserModule),
      },
      {
        path: "error",
        component: ErrorPageComponent,
        data: {
          type: 404,
          title: "Page Not Found",
          desc: "Oopps!! The page you were looking for doesn't exist.",
        },
      },
      {
        path: "roles",
        loadChildren: () =>
          import("./modules/roles/role.module").then((m) => m.RoleModule),
      },
      // {
      //   path: 'roles-manager',
      //   loadChildren: () => import('./modules/roles-manager/role.module').then(m => m.RoleModule)
      // },
      // {
      //   path: 'dashboardbuilder/:Id',
      //   loadChildren: () => import('./modules/dashboard-builder/config/customedashboard.module').then(m => m.CustomDashboardModule)
      // }
    ],
  },
  {
    path: "error",
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: "Page Not Found",
      desc: "Oopps!! The page you were looking for doesn't exist.",
    },
  },
  {
    path: "error/:type",
    component: ErrorPageComponent,
  },
  { path: "**", redirectTo: "error", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
